import React from 'react'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'components/Luxkit/Typography/Heading'
import { rem } from 'polished'
import CategoryTile from 'components/Luxkit/CategoryTile'
import FullWidthCarousel from 'components/Luxkit/Carousel/FullWidthCarousel'
import { mediaQueryUp } from 'components/utils/breakpoint'
import styled from 'styled-components'
import Group from 'components/utils/Group'

const TravelPane = styled(Group)`
  padding: ${rem(24)} 0;
  background: ${props => props.theme.palette.neutral.default.eight};

  ${mediaQueryUp.tablet} {
    padding: ${rem(40)} 0;
  }
`

interface Props {
  title: string
  tiles: Array<any>
}
function ContentfulImageTileCarousel(props: Props) {
  const { title, tiles } = props

  return (
    <TravelPane direction="vertical" gap={20}>
      <LayoutContainer>
        <Heading variant="heading2">{title}</Heading>
      </LayoutContainer>
      <FullWidthCarousel
        itemsPerArrow={6}
        snap="start"
        gap={12}
        width={rem(180)}
      >
        {tiles.map((tile: any) => (
          <CategoryTile
            key={tile.linkTo}
            heading={tile.title}
            subHeading={tile.subtitle}
            align="top"
            callToAction={tile.linkText}
            to={tile.linkTo}
            image={tile.image}
          />
        ))}
      </FullWidthCarousel>
    </TravelPane>
  )
}

export default ContentfulImageTileCarousel
